import { render, staticRenderFns } from "./VmContainer.vue?vue&type=template&id=77577a22"
import script from "./VmContainer.vue?vue&type=script&lang=js"
export * from "./VmContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports